const DeliverySaverComingSoonComponentDefinition = {
    template: require('./delivery-saver-coming-soon.component.html').trim(),
};

module.exports = { DeliverySaverComingSoonComponentDefinition };



// WEBPACK FOOTER //
// ./src/deliverysaver/comingsoon/delivery-saver-coming-soon.component.js